import $ from 'jquery';
(function ($) {
    // Open Modal
    $(document).on("click", "[js-open-modal]", function() {
        if($(this).attr('data-target')){
            if($(this).attr('data-content')){
                $('#modal-email').find('#url_share').val($(this).attr('data-content'));
            }
            appear($(this).attr('data-target'));
        }
    });

    // Close modal
    $(document).on("click", ".modal", function(e) {
        if (e.target !== this && !$(e.target).hasClass('close-modal')){
            return;
        }
        closeModal($('.modal'));
    });

    $(document).on('click', '.closeModal' , function(e){
        closeModal($('.modal'));
    });

    function closeModal(el){
        el.fadeOut();
        cleanErrors();
    }
    function appear(attr){
        $('.modal[' + attr + ']').fadeIn();
        $('.modal[' + attr + ']').css('display', 'flex');
    }

    function cleanErrors(){
        $('.modal .control.error').removeClass('error');
    }

})(jQuery);